import { DataTableSortEvent } from 'primereact/datatable'

import { TSortType } from '../../../Register/CustomerSubscription/useCustomerSubscriptionService'

export const tableApiSort = (
  event: DataTableSortEvent,
  urlSearchParams: URLSearchParams,
): string => {
  if (event.multiSortMeta) {
    const eventData = event.multiSortMeta[0]
    if (event.multiSortMeta.length === 0) {
      urlSearchParams.delete('sort')
      urlSearchParams.set('offset', '0')
    } else {
      const sortType = eventData.field as TSortType
      const sortDirection = eventData.order === 1 ? 'asc' : 'desc'
      const sortParam = `${sortType}:${sortDirection}`
      urlSearchParams.set('sort', sortParam)
      urlSearchParams.set('offset', '0')
    }
    const newSort = urlSearchParams.toString()
    return newSort
  }
  // TODO if using table with no multiSortMeta, complete this
  return ''
}

export const primeSortOrder = (sortOrder: string | null): 0 | 1 | -1 => {
  if (sortOrder) {
    return sortOrder.split(':')[1] === 'asc' ? 1 : -1
  }
  return 0
}

export const primeSortField = (sortField: string | null): string | undefined => {
  if (sortField) {
    return sortField.split(':')[0]
  }
  return undefined
}

export const primeOffset = (offsetParam: string | null): number => {
  if (offsetParam) {
    return Number(offsetParam)
  }
  return 0
}

export const primeLimit = (limitParam: string | null): number => {
  if (limitParam) {
    return Number(limitParam)
  }
  return 20
}